/* Frontend Core JS Bundle. Generated by scripts/build_frontend_js_bundles.sh. */
/* Source order: base loader, shell navigation. Keep feature modules lazy through g3LoadFrontendScript. */


/* ==== base.js ==== */
(() => {
    const loadedScripts = new Set();
    let parsedAssetMap = null;
    const scriptRetryCount = new Map();

    const getAssetVersion = () => {
        const fromBody = document.body?.dataset?.assetVersion;
        if (typeof fromBody === "string" && fromBody.trim()) {
            return fromBody.trim();
        }
        return String(window.__g3AssetVersion || "").trim();
    };
    const getAssetMap = () => {
        const map = window.__g3AssetMap;
        return map && typeof map === "object" ? map : {};
    };
    const readAssetMapScript = () => {
        if (parsedAssetMap !== null) {
            return parsedAssetMap;
        }
        const el = document.getElementById("g3-asset-map");
        if (el instanceof HTMLTemplateElement) {
            parsedAssetMap = {};
            el.content.querySelectorAll("[data-g3-asset-path][data-g3-asset-src]").forEach((node) => {
                const path = String(node.getAttribute("data-g3-asset-path") || "").trim();
                const src = String(node.getAttribute("data-g3-asset-src") || "").trim();
                if (path && src) {
                    parsedAssetMap[path] = src;
                }
            });
            return parsedAssetMap;
        }

        if (el instanceof HTMLScriptElement) {
            try {
                const parsed = JSON.parse(el.textContent || "{}");
                parsedAssetMap = parsed && typeof parsed === "object" ? parsed : {};
            } catch (_) {
                parsedAssetMap = {};
            }
            return parsedAssetMap;
        }

        parsedAssetMap = {};
        return parsedAssetMap;
    };
    const normalizeAssetPath = (path) => {
        const raw = String(path || "").trim();
        if (!raw) return "";
        const mapped = String(readAssetMapScript()[raw] || getAssetMap()[raw] || "").trim();
        if (mapped) {
            return mapped;
        }
        if (/^(?:https?:)?\/\//i.test(raw)) {
            return raw;
        }
        if (raw.startsWith("/")) {
            return raw;
        }
        if (raw.startsWith("static/")) {
            return `/${raw}`;
        }
        return `/static/${raw}`;
    };
    const buildAssetUrl = (path) => {
        const normalizedPath = normalizeAssetPath(path);
        if (!normalizedPath) return "";
        const version = getAssetVersion();
        if (!version) return normalizedPath;
        const separator = normalizedPath.includes("?") ? "&" : "?";
        return `${normalizedPath}${separator}v=${encodeURIComponent(version)}`;
    };
    const getAssetReadyFlag = (path) => {
        const normalized = String(path || "").trim();
        if (normalized.endsWith("/inquiry.js")) {
            return "__g3InquiryScriptReady";
        }
        return "";
    };
    const buildRetryUrl = (src) => {
        const separator = src.includes("?") ? "&" : "?";
        return `${src}${separator}rt=${Date.now()}`;
    };
    const appendScript = (src, readyFlag, path, allowRetry) => new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = src;
        script.defer = true;
        script.onload = () => {
            const isReady = !readyFlag || window[readyFlag] === true;
            if (isReady) {
                loadedScripts.add(src);
                scriptRetryCount.delete(path);
                resolve(src);
                return;
            }
            script.remove();
            reject(new Error(`Incomplete script execution for ${src}`));
        };
        script.onerror = () => {
            script.remove();
            reject(new Error(`Failed to load ${src}`));
        };
        document.body.appendChild(script);
    }).catch((error) => {
        const currentRetry = scriptRetryCount.get(path) || 0;
        if (!allowRetry || currentRetry >= 1) {
            throw error;
        }
        scriptRetryCount.set(path, currentRetry + 1);
        return appendScript(buildRetryUrl(src), readyFlag, path, false);
    });
    const loadScript = (path) => {
        const src = buildAssetUrl(path);
        if (!src) {
            return Promise.reject(new Error("Missing script path"));
        }
        if (loadedScripts.has(src)) {
            return Promise.resolve(src);
        }
        const readyFlag = getAssetReadyFlag(path);
        return appendScript(src, readyFlag, path, true);
    };
    const scheduleIdle = (callback, timeout = 1200) => {
        if ("requestIdleCallback" in window) {
            window.requestIdleCallback(callback, { timeout });
            return;
        }
        window.setTimeout(callback, timeout);
    };

    window.g3LoadFrontendScript = loadScript;
    window.g3BuildFrontendAssetUrl = buildAssetUrl;
    window.g3NormalizeFrontendAssetPath = normalizeAssetPath;
    window.g3ScheduleIdleTask = scheduleIdle;
})();

(() => {
    const queue = Array.isArray(window.__g3AnalyticsEventQueue) ? window.__g3AnalyticsEventQueue : [];
    const cleanString = (value) => {
        if (value === null || value === undefined) return "";
        return String(value).trim();
    };
    const parseEntityId = (raw) => {
        const normalized = cleanString(raw);
        if (!normalized) return null;
        const parsed = Number.parseInt(normalized, 10);
        return Number.isFinite(parsed) ? parsed : null;
    };
    const normalizePayload = (payload) => {
        if (!payload || typeof payload !== "object") return null;
        const name = cleanString(payload.name);
        if (!name) return null;
        const normalized = {
            name,
            path: cleanString(payload.path || window.location.pathname || ""),
            full_url: cleanString(payload.full_url || window.location.href || ""),
            entity_type: cleanString(payload.entity_type || ""),
            metadata: payload.metadata && typeof payload.metadata === "object" ? payload.metadata : {},
        };
        const entityId = parseEntityId(payload.entity_id);
        if (entityId !== null) {
            normalized.entity_id = entityId;
        }
        return normalized;
    };

    window.__g3AnalyticsEventQueue = queue;
    if (typeof window.g3TrackAnalyticsEvent !== "function") {
        window.g3TrackAnalyticsEvent = (payload) => {
            const normalized = normalizePayload(payload);
            if (!normalized) return;
            queue.push(normalized);
        };
    }
})();

(() => {
    const activateAsyncStylesheet = (link) => {
        if (!(link instanceof HTMLLinkElement)) return;
        if (link.dataset.g3AsyncStyleApplied === "1" || link.media === "all") {
            return;
        }
        const deferredHref = link.dataset.g3AsyncHref;
        if (deferredHref && !link.getAttribute("href")) {
            link.href = deferredHref;
        }
        const apply = () => {
            if (link.dataset.g3AsyncStyleApplied === "1") {
                return;
            }
            link.media = "all";
            link.dataset.g3AsyncStyleApplied = "1";
        };
        if (link.sheet) {
            apply();
            return;
        }
        link.addEventListener("load", apply, { once: true });
        window.setTimeout(apply, 2200);
    };

    const scheduleStylesheet = (link) => {
        if (!(link instanceof HTMLLinkElement)) return;
        if (link.dataset.g3AsyncCssDelay !== "idle") {
            activateAsyncStylesheet(link);
            return;
        }
        const delayMs = Number.parseInt(link.dataset.g3AsyncCssDelayMs || "", 10);
        const minDelay = Number.isFinite(delayMs) && delayMs >= 0 ? delayMs : 1800;
        const apply = () => {
            const schedule = window.g3ScheduleIdleTask || ((fn) => window.setTimeout(fn, 1200));
            window.setTimeout(() => {
                schedule(() => activateAsyncStylesheet(link), 900);
            }, minDelay);
        };
        if (document.readyState === "complete") {
            apply();
            return;
        }
        window.addEventListener("load", apply, { once: true });
    };

    const run = () => {
        document.querySelectorAll('link[data-g3-async-css="1"]').forEach(scheduleStylesheet);
    };

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", run, { once: true });
    } else {
        run();
    }
})();

(() => {
    const applyCssVarValue = (selector, dataKey, cssVar, transform = (value) => value) => {
        document.querySelectorAll(selector).forEach((node) => {
            if (!(node instanceof HTMLElement)) return;
            const rawValue = String(node.dataset[dataKey] || "").trim();
            if (!rawValue) return;
            const value = transform(rawValue);
            if (!value) return;
            node.style.setProperty(cssVar, value);
        });
    };

    const applyNumericCssVar = (selector, dataKey, cssVar) => {
        document.querySelectorAll(selector).forEach((node) => {
            if (!(node instanceof HTMLElement)) return;
            const rawValue = Number.parseInt(node.dataset[dataKey] || "", 10);
            if (!Number.isFinite(rawValue)) return;
            node.style.setProperty(cssVar, String(rawValue));
        });
    };

    const run = () => {
        applyNumericCssVar("[data-stagger]", "stagger", "--stagger-index");
        applyNumericCssVar("[data-hero-mobile-lines]", "heroMobileLines", "--hero-mobile-lines");
        applyCssVarValue("[data-home-hero-bg-color]", "homeHeroBgColor", "--home-hero-bg-color");
        applyCssVarValue("[data-home-hero-height]", "homeHeroHeight", "--home-hero-height");
        applyCssVarValue("[data-home-hero-mobile-height]", "homeHeroMobileHeight", "--home-hero-mobile-height");
        applyCssVarValue("[data-managed-promo-desktop-ratio]", "managedPromoDesktopRatio", "--managed-promo-slot-desktop-ratio");
        applyCssVarValue("[data-managed-promo-mobile-ratio]", "managedPromoMobileRatio", "--managed-promo-slot-mobile-ratio");
        applyCssVarValue("[data-popular-marquee-duration]", "popularMarqueeDuration", "--popular-marquee-duration", (value) => `${Number.parseFloat(value) || 0}s`);
    };

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", run, { once: true });
    } else {
        run();
    }
})();

(() => {
    const looksPhoneCapable = () => {
        const ua = String(window.navigator?.userAgent || "");
        const touchPoints = Number(window.navigator?.maxTouchPoints || 0);
        const coarsePointer = Boolean(window.matchMedia?.("(hover: none), (pointer: coarse)")?.matches);
        return coarsePointer && (touchPoints > 0 || /android|iphone|ipod|mobile/i.test(ua));
    };

    const apply = () => {
        const enabled = looksPhoneCapable();
        document.documentElement.classList.toggle("has-call-capable-device", enabled);
        if (document.body) {
            document.body.classList.toggle("has-call-capable-device", enabled);
        }
    };

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", apply, { once: true });
    } else {
        apply();
    }
})();

(() => {
    const UNSAFE_METHODS = new Set(["POST", "PUT", "PATCH", "DELETE"]);
    let securityBootstrapPromise = null;
    const getCookieToken = () => {
        const match = document.cookie.match(/(?:^|;\s*)csrftoken=([^;]+)/);
        return match && match[1] ? decodeURIComponent(match[1]) : "";
    };
    const getScopedInputToken = (scope) => {
        if (!(scope instanceof Element)) return "";
        const field = scope.querySelector('input[name="csrfmiddlewaretoken"]');
        if (!field) return "";
        const value = String(field.value || "").trim();
        return value && value !== "NOTPROVIDED" ? value : "";
    };
    const getAnyInputToken = () => {
        const field = document.querySelector('input[name="csrfmiddlewaretoken"]');
        if (!field) return "";
        const value = String(field.value || "").trim();
        return value && value !== "NOTPROVIDED" ? value : "";
    };
    const getMetaToken = () => {
        const fromMeta = document.querySelector('meta[name="csrf-token"]');
        if (!fromMeta) return "";
        const value = String(fromMeta.content || "").trim();
        return value && value !== "NOTPROVIDED" ? value : "";
    };
    const getBootstrapToken = () => {
        const value = String(window.__g3BootstrapCsrfToken || "").trim();
        return value && value !== "NOTPROVIDED" ? value : "";
    };
    const getLeadGuardToken = (scope = null) => {
        if (scope instanceof Element) {
            const scoped = scope.querySelector('input[name="lead_guard_token"]');
            const scopedValue = String(scoped?.value || "").trim();
            if (scopedValue) return scopedValue;
        }
        const field = document.querySelector('input[name="lead_guard_token"]');
        const value = String(field?.value || window.__g3LeadGuardToken || "").trim();
        return value;
    };
    const loadSecurityBootstrap = () => {
        if (securityBootstrapPromise) {
            return securityBootstrapPromise;
        }
        const endpoint = String(document.body?.dataset?.csrfBootstrapUrl || "/ui/csrf/").trim() || "/ui/csrf/";
        const bootstrapUrl = new URL(endpoint, window.location.origin);
        const pagePath = `${window.location.pathname || "/"}${window.location.search || ""}`;
        if (pagePath) {
            bootstrapUrl.searchParams.set("page", pagePath);
        }
        securityBootstrapPromise = fetch(bootstrapUrl.toString(), {
            credentials: "same-origin",
            headers: { "X-Requested-With": "XMLHttpRequest" },
        })
            .then((response) => (response.ok ? response.json() : {}))
            .then((payload) => {
                const csrfToken = String(payload?.csrfToken || "").trim();
                const leadGuardToken = String(payload?.leadGuardToken || "").trim();
                if (csrfToken) {
                    window.__g3BootstrapCsrfToken = csrfToken;
                }
                if (leadGuardToken) {
                    window.__g3LeadGuardToken = leadGuardToken;
                }
                return { csrfToken, leadGuardToken };
            })
            .catch(() => ({}))
            .finally(() => {
                window.setTimeout(() => {
                    securityBootstrapPromise = null;
                }, 1500);
            });
        return securityBootstrapPromise;
    };
    // The bootstrap token (/ui/csrf/) is minted for this browser's own cookie, so it wins
    // over a token baked into the HTML: public pages are cached and served to everyone,
    // and the cached token belongs to whoever rendered the page first (a 403 for anyone else).
    const getCsrfToken = (scope = null) => (
        getBootstrapToken()
        || getScopedInputToken(scope)
        || getAnyInputToken()
        || getMetaToken()
        || getCookieToken()
    );
    const ensureCsrfInput = (form, explicitToken = "") => {
        if (!(form instanceof HTMLFormElement)) return "";
        const existing = getScopedInputToken(form);
        const fresh = getBootstrapToken();
        if (fresh && existing !== fresh) {
            form.querySelectorAll('input[name="csrfmiddlewaretoken"]').forEach((field) => {
                field.value = fresh;
            });
            if (existing) return fresh;
        }
        if (existing) return existing;
        const token = String(explicitToken || getCsrfToken(form) || "").trim();
        if (!token) return "";
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = "csrfmiddlewaretoken";
        input.value = token;
        form.prepend(input);
        return token;
    };
    const ensureLeadGuardInput = async (form, options = {}) => {
        const refresh = Boolean(options?.refresh);
        if (!(form instanceof HTMLFormElement)) {
            const data = await loadSecurityBootstrap();
            return String(data?.leadGuardToken || getLeadGuardToken() || "").trim();
        }
        const existing = getLeadGuardToken(form);
        if (!refresh && existing) return existing;
        const data = await loadSecurityBootstrap();
        const token = String(data?.leadGuardToken || existing || getLeadGuardToken(form) || "").trim();
        if (!token) return "";
        let input = form.querySelector('input[name="lead_guard_token"]');
        if (!input) {
            input = document.createElement("input");
            input.type = "hidden";
            input.name = "lead_guard_token";
            form.prepend(input);
        }
        input.value = token;
        return token;
    };
    const isSameOrigin = (url) => {
        try {
            return new URL(url, window.location.href).origin === window.location.origin;
        } catch (_) {
            return true;
        }
    };

    window.g3GetCsrfToken = getCsrfToken;
    window.g3EnsureCsrfInput = ensureCsrfInput;
    window.g3GetLeadGuardToken = getLeadGuardToken;
    window.g3EnsureLeadGuardInput = ensureLeadGuardInput;
    window.g3LoadSecurityBootstrap = loadSecurityBootstrap;
    window.g3Fetch = (url, options = {}) => {
        const next = { ...options };
        const method = String(next.method || "GET").toUpperCase();
        const headers = new Headers(next.headers || {});
        const sameOrigin = isSameOrigin(url);
        const isUnsafeSameOrigin = sameOrigin && UNSAFE_METHODS.has(method);
        if (isUnsafeSameOrigin && !headers.has("X-CSRFToken")) {
            const token = getCsrfToken(next.form || null);
            if (token) {
                headers.set("X-CSRFToken", token);
            } else if (window.location.hostname === "127.0.0.1" || window.location.hostname === "localhost") {
                console.warn("[g3Fetch] Missing CSRF token for unsafe request", { url, method });
            }
        }
        if (isUnsafeSameOrigin && !headers.has("X-Requested-With")) {
            headers.set("X-Requested-With", "XMLHttpRequest");
        }
        if (!next.credentials) {
            next.credentials = "same-origin";
        }
        next.headers = headers;
        return fetch(url, next);
    };
})();

(() => {
    const applyFallback = (img) => {
        if (!(img instanceof HTMLImageElement)) return;
        const fallbackSrc = String(img.dataset.fallbackSrc || "").trim();
        if (!fallbackSrc || img.dataset.fallbackApplied === "1") return;
        img.dataset.fallbackApplied = "1";
        img.src = fallbackSrc;
        img.classList.add("is-fallback-image");
    };

    document.addEventListener(
        "error",
        (event) => {
            const target = event.target;
            if (target instanceof HTMLImageElement) {
                applyFallback(target);
            }
        },
        true
    );
})();

(() => {
    if (window.location.hash === "#loan" && window.location.pathname === "/") {
        window.location.replace("/home-loan/");
    }
})();

(() => {
    if (window.location.hash) {
        return;
    }
    try {
        if ("scrollRestoration" in history) {
            history.scrollRestoration = "manual";
        }
        const filterKey = `g3:filter-scroll:${window.location.pathname}`;
        if (sessionStorage.getItem(filterKey)) {
            return;
        }
        const key = `g3:scroll:${window.location.pathname}${window.location.search}`;
        const raw = sessionStorage.getItem(key);
        if (!raw) {
            return;
        }
        const y = Number(raw);
        if (!Number.isFinite(y) || y <= 0) {
            return;
        }
        document.documentElement.classList.add("scroll-restoring");
        document.documentElement.style.scrollBehavior = "auto";
        window.__g3PendingScrollRestore = {
            key,
            y,
        };
    } catch (_) {
        /* ignore scroll bootstrap issues */
    }
})();

(() => {
    const key = `g3:scroll:${window.location.pathname}${window.location.search}`;
    const filterKey = `g3:filter-scroll:${window.location.pathname}`;
    let restored = false;
    let previousScrollBehavior = "";
    const disableSmoothScroll = () => {
        previousScrollBehavior = document.documentElement.style.scrollBehavior || "";
        document.documentElement.style.scrollBehavior = "auto";
    };
    const restoreScrollBehavior = () => {
        if (previousScrollBehavior) {
            document.documentElement.style.scrollBehavior = previousScrollBehavior;
            return;
        }
        document.documentElement.style.removeProperty("scroll-behavior");
    };
    const releaseVisualLock = () => {
        restoreScrollBehavior();
        document.documentElement.classList.remove("scroll-restoring");
    };
    const canStore = () => {
        try {
            sessionStorage.setItem("__g3_scroll_test", "1");
            sessionStorage.removeItem("__g3_scroll_test");
            return true;
        } catch (_) {
            return false;
        }
    };
    const store = () => {
        if (!canStore()) return;
        try {
            sessionStorage.setItem(key, String(window.scrollY || window.pageYOffset || 0));
        } catch (_) {
            /* ignore storage issues */
        }
    };
    const restore = () => {
        if (restored || !canStore() || window.location.hash) return;
        try {
            if (sessionStorage.getItem(filterKey)) return;
        } catch (_) {
            /* ignore storage issues */
        }
        let raw = null;
        try {
            raw = sessionStorage.getItem(key);
        } catch (_) {
            raw = null;
        }
        const pending = window.__g3PendingScrollRestore;
        if ((!raw || raw === "") && pending && pending.key === key) {
            raw = String(pending.y || "");
        }
        if (!raw) return;
        const y = Number(raw);
        if (!Number.isFinite(y)) return;
        restored = true;
        try {
            sessionStorage.removeItem(key);
        } catch (_) {
            /* ignore storage issues */
        }
        delete window.__g3PendingScrollRestore;
        const retryDelays = [0, 80, 180, 320, 560];
        let resizeObserver = null;
        let finalized = false;
        const timerIds = [];
        const cancelEvents = ["wheel", "touchstart", "touchmove", "pointerdown", "keydown"];
        const cancelOptions = { capture: true, passive: true };
        const getMaxScrollY = () => {
            const body = document.body;
            const root = document.documentElement;
            const scrollHeight = Math.max(
                body?.scrollHeight || 0,
                root?.scrollHeight || 0,
                body?.offsetHeight || 0,
                root?.offsetHeight || 0
            );
            return Math.max(0, scrollHeight - window.innerHeight);
        };
        const apply = () => {
            if (finalized || window.__g3ScrollRestoreUserCancelled) return false;
            if (getMaxScrollY() + 2 < y) return false;
            window.scrollTo({ top: y, left: 0, behavior: "auto" });
            return true;
        };
        const finalize = () => {
            if (finalized) return;
            finalized = true;
            timerIds.forEach((timerId) => window.clearTimeout(timerId));
            if (resizeObserver) {
                resizeObserver.disconnect();
                resizeObserver = null;
            }
            cancelEvents.forEach((eventName) => {
                window.removeEventListener(eventName, cancelRestore, cancelOptions);
            });
            if (typeof window.__g3DetachPendingScrollRestoreCancel === "function") {
                window.__g3DetachPendingScrollRestoreCancel();
            }
            releaseVisualLock();
        };
        const cancelRestore = () => {
            window.__g3ScrollRestoreUserCancelled = true;
            finalize();
        };
        disableSmoothScroll();
        cancelEvents.forEach((eventName) => {
            window.addEventListener(eventName, cancelRestore, cancelOptions);
        });
        retryDelays.forEach((delay) => {
            const timerId = window.setTimeout(() => {
                if (apply()) {
                    finalize();
                }
            }, delay);
            timerIds.push(timerId);
        });
        if ("ResizeObserver" in window) {
            resizeObserver = new ResizeObserver(() => {
                if (apply()) {
                    finalize();
                }
            });
            if (document.body) {
                resizeObserver.observe(document.body);
            }
            resizeObserver.observe(document.documentElement);
        }
        timerIds.push(window.setTimeout(() => {
            finalize();
        }, 900));
        window.addEventListener(
            "load",
            () => {
                if (apply()) {
                    finalize();
                    return;
                }
                timerIds.push(window.setTimeout(finalize, 60));
            },
            { once: true }
        );
    };
    if ("scrollRestoration" in history) {
        history.scrollRestoration = "manual";
    }
    window.addEventListener("pagehide", store);
    window.addEventListener("beforeunload", store);
    window.addEventListener("pageshow", restore);
    window.setTimeout(() => {
        if (document.documentElement.classList.contains("scroll-restoring")) {
            releaseVisualLock();
        }
    }, 2800);
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", restore, { once: true });
    } else {
        restore();
    }
})();

(() => {
    document.addEventListener("click", (event) => {
        const trigger = event.target.closest("[data-confirm-submit]");
        if (!(trigger instanceof HTMLElement)) {
            return;
        }
        const message = String(trigger.dataset.confirmSubmit || "Are you sure?").trim() || "Are you sure?";
        if (window.confirm(message)) {
            return;
        }
        event.preventDefault();
        event.stopPropagation();
    });
})();

(() => {
    const leadKey = "g3:lead-submitted";
    const detailKey = "g3:lead-details";
    const has = () => {
        try {
            return localStorage.getItem(leadKey) === "1";
        } catch (_) {
            return false;
        }
    };
    const mark = () => {
        try {
            localStorage.setItem(leadKey, "1");
        } catch (_) {
            /* ignore storage issues */
        }
    };
    const readDetails = () => {
        try {
            const raw = localStorage.getItem(detailKey);
            return raw ? JSON.parse(raw) : {};
        } catch (_) {
            return {};
        }
    };
    const writeDetails = (payload) => {
        try {
            localStorage.setItem(detailKey, JSON.stringify(payload || {}));
        } catch (_) {
            /* ignore storage issues */
        }
    };
    const captureFromForm = (form) => {
        if (!form) return;
        const details = readDetails();
        const fields = ["name", "phone", "email", "isd_code", "country", "budget", "message"];
        fields.forEach((field) => {
            const input = form.querySelector(`[name="${field}"]`);
            if (!input || input.type === "hidden") return;
            const value = (input.value || "").trim();
            if (value) details[field] = value;
        });
        writeDetails(details);
    };
    const applyToForm = (form) => {
        if (!form) return;
        const details = readDetails();
        if (!details || typeof details !== "object") return;
        const skipMessage = (
            form.dataset.noMessagePrefill === "true"
            || form.closest(".static-inquiry")
            || form.classList.contains("listing-inquiry-form")
            || form.querySelector('input[name="listing_id"]')
            || form.querySelector('input[name="listing_title"]')
            || form.id === "lead-form"
            || form.id === "lead-form-modal"
        );
        Object.entries(details).forEach(([field, value]) => {
            if (field === "message" && skipMessage) return;
            const input = form.querySelector(`[name="${field}"]`);
            if (!input || input.type === "hidden" || input.value) return;
            input.value = value;
        });
    };
    window.g3LeadSubmission = {
        has,
        mark,
        key: leadKey,
        detailsKey: detailKey,
        readDetails,
        writeDetails,
        captureFromForm,
        applyToForm,
    };
})();

(() => {
    const ensureMainContentTarget = () => {
        if (document.getElementById("main-content")) return;
        const main = document.querySelector("main");
        if (!main) return;
        main.id = "main-content";
        if (!main.hasAttribute("tabindex")) {
            main.setAttribute("tabindex", "-1");
        }
    };

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", ensureMainContentTarget, { once: true });
    } else {
        ensureMainContentTarget();
    }
})();

(() => {
    const root = document.documentElement;
    if (!root) return;

    const api = window.g3Layout || {};
    api.setPageWidth = (widthValue) => {
        const value = String(widthValue || "").trim();
        if (value) {
            root.style.setProperty("--layout-width-manager", value);
        }
    };
    api.getPageWidth = () => getComputedStyle(root).getPropertyValue("--layout-width-manager").trim();
    window.g3Layout = api;
})();

(() => {
    const ensureId = (() => {
        let seq = 1;
        return (el) => {
            if (!(el instanceof Element)) return "";
            if (el.id) return el.id;
            const generated = `g3-auto-field-${seq++}`;
            el.id = generated;
            return generated;
        };
    })();

    const bindOrphanLabels = () => {
        document.querySelectorAll("label:not([for])").forEach((label) => {
            if (!(label instanceof HTMLLabelElement)) return;
            const nested = label.querySelector("input, select, textarea");
            if (nested) {
                label.setAttribute("for", ensureId(nested));
                return;
            }
            let sibling = label.nextElementSibling;
            while (sibling) {
                let target = null;
                if (sibling.matches && sibling.matches("input, select, textarea")) {
                    target = sibling;
                } else if (sibling.querySelector) {
                    target = sibling.querySelector("input, select, textarea");
                }
                if (target) {
                    label.setAttribute("for", ensureId(target));
                    return;
                }
                sibling = sibling.nextElementSibling;
            }
        });
    };

    const hasAccessibleName = (el) => {
        if (!(el instanceof Element)) return true;
        if (el.hasAttribute("aria-label") || el.hasAttribute("aria-labelledby") || el.hasAttribute("title")) {
            return true;
        }
        return Boolean((el.textContent || "").trim());
    };

    const deriveAccessibleName = (el) => {
        if (!(el instanceof Element)) return "";
        const dataset = el.dataset || {};
        if (dataset.platform) return `${dataset.platform} action`;
        if (dataset.view) return `${dataset.view} view`;
        if (dataset.action) return dataset.action;
        if (el instanceof HTMLAnchorElement) {
            const href = (el.getAttribute("href") || "").trim().toLowerCase();
            if (href.startsWith("tel:")) return "Call";
            if (href.startsWith("mailto:")) return "Send email";
            if (href.startsWith("https://wa.me/") || href.includes("whatsapp")) return "Open Chat";
            return "Open link";
        }
        return "Open action";
    };

    const patchUnnamedControls = () => {
        document.querySelectorAll("button, a").forEach((el) => {
            if (hasAccessibleName(el)) return;
            const fallback = deriveAccessibleName(el);
            if (fallback) {
                el.setAttribute("aria-label", fallback);
            }
        });
    };

    const titleCase = (value) => String(value || "")
        .trim()
        .replace(/[_-]+/g, " ")
        .replace(/\s+/g, " ")
        .replace(/\b\w/g, (char) => char.toUpperCase());

    const hasProgrammaticLabel = (el) => {
        if (!(el instanceof Element)) return true;
        if (el.hasAttribute("aria-label") || el.hasAttribute("aria-labelledby") || el.hasAttribute("title")) {
            return true;
        }
        if (!(el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement || el instanceof HTMLSelectElement)) {
            return true;
        }
        if (el instanceof HTMLInputElement) {
            const type = (el.type || "").toLowerCase();
            if (["hidden", "submit", "button", "reset", "image"].includes(type)) {
                return true;
            }
        }
        if (el.id && document.querySelector(`label[for="${CSS.escape(el.id)}"]`)) {
            return true;
        }
        return Boolean(el.closest("label"));
    };

    const deriveFieldLabel = (el) => {
        if (!(el instanceof Element)) return "";
        const placeholder = String(el.getAttribute("placeholder") || "").trim();
        if (placeholder) {
            return placeholder.replace(/\s*\(optional\)\s*/gi, "").trim();
        }
        const name = String(el.getAttribute("name") || "").trim();
        if (name) {
            return titleCase(name);
        }
        if (el instanceof HTMLInputElement) {
            const type = (el.type || "").toLowerCase();
            if (type === "email") return "Email address";
            if (type === "tel") return "Phone number";
            if (type === "number") return "Numeric value";
        }
        if (el instanceof HTMLTextAreaElement) {
            return "Message";
        }
        if (el instanceof HTMLSelectElement) {
            return "Select option";
        }
        return "";
    };

    const patchUnnamedFields = () => {
        document.querySelectorAll("input, textarea, select").forEach((el) => {
            if (hasProgrammaticLabel(el)) return;
            const fallback = deriveFieldLabel(el);
            if (fallback) {
                el.setAttribute("aria-label", fallback);
            }
        });
    };

    const run = () => {
        bindOrphanLabels();
        patchUnnamedControls();
        patchUnnamedFields();
    };

    const scheduleRun = () => {
        const schedule = window.g3ScheduleIdleTask || ((fn, timeout = 1200) => window.setTimeout(fn, timeout));
        const afterLoad = () => {
            window.setTimeout(() => {
                schedule(run, 900);
            }, 1800);
        };
        if (document.readyState === "complete") {
            afterLoad();
            return;
        }
        window.addEventListener("load", afterLoad, { once: true });
    };

    scheduleRun();
})();

(() => {
    const hasAny = (selectors) => {
        try {
            return Boolean(document.querySelector(selectors));
        } catch (_) {
            return false;
        }
    };

    const boot = () => {
        const load = window.g3LoadFrontendScript;
        const scheduleIdle = window.g3ScheduleIdleTask || ((fn) => window.setTimeout(fn, 1200));
        if (typeof load !== "function") return;

        const loadOnWindowIdle = (cb, timeout = 1600) => {
            window.addEventListener("load", () => {
                window.setTimeout(() => {
                    scheduleIdle(cb, 900);
                }, timeout);
            }, { once: true });
        };

        const loadAfterDelayOrInput = (cb, delay = 8000) => {
            let done = false;
            let timerId = 0;
            const events = ["pointerdown", "keydown"];
            const cleanup = () => {
                events.forEach((eventName) => {
                    window.removeEventListener(eventName, run, { capture: true });
                });
                if (timerId) {
                    window.clearTimeout(timerId);
                }
            };
            const run = () => {
                if (done) return;
                done = true;
                cleanup();
                cb();
            };
            window.addEventListener("load", () => {
                timerId = window.setTimeout(() => {
                    scheduleIdle(run, 900);
                }, delay);
            }, { once: true });
            events.forEach((eventName) => {
                window.addEventListener(eventName, run, { once: true, passive: true, capture: true });
            });
        };

        const loadDeferred = (src, delay = 6000) => {
            loadAfterDelayOrInput(() => {
                load(src).catch(() => {});
            }, delay);
        };
        const loadPageModule = (dataKey, delay = 1800, mode = "interaction") => {
            const src = String(document.body?.dataset?.[dataKey] || "").trim();
            if (!src) return;
            const run = () => {
                load(src).catch(() => {});
            };
            if (mode === "immediate") {
                run();
                return;
            }
            if (mode === "idle") {
                loadOnWindowIdle(run, delay);
                return;
            }
            loadAfterDelayOrInput(run, delay);
        };

        const hasHeroBlock = hasAny("[data-hero-block]");
        const hasHeroCandidate = hasAny([
            "[data-hero-block]",
            ".listing-hero > p",
            ".project-hero > p",
            ".project-hero-content > p",
            ".static-hero > p",
            ".projects-hero > p",
            ".shortcuts-hero > p",
            ".nri-hero-copy > p",
            ".blog-hero > p",
            ".testimonial-hero > p",
            ".project-hero h1",
            ".listing-hero h1",
        ].join(", "));
        if (hasHeroBlock) {
            load("frontend/site/common/js/hero-ui.js").catch(() => {});
        } else if (hasHeroCandidate) {
            loadDeferred("frontend/site/common/js/hero-ui.js", 5000);
        }

        if (hasAny("[data-collapse-rows]")) {
            load("frontend/site/common/js/grid-collapse.js").catch(() => {});
        }

        const scheduleVisitTriggerSelector = "[data-schedule-visit-trigger]";
        const hasScheduleVisitTrigger = hasAny(scheduleVisitTriggerSelector);
        let scheduleVisitLoadPromise = null;
        const ensureScheduleVisitScript = () => {
            if (window.__g3ScheduleVisitReady === true) {
                return Promise.resolve();
            }
            if (!scheduleVisitLoadPromise) {
                scheduleVisitLoadPromise = load("frontend/site/common/js/schedule-visit.js")
                    .catch((error) => {
                        scheduleVisitLoadPromise = null;
                        throw error;
                    });
            }
            return scheduleVisitLoadPromise;
        };
        if (hasScheduleVisitTrigger) {
            document.addEventListener("click", (event) => {
                if (window.__g3ScheduleVisitReady === true) return;
                const trigger = event.target instanceof Element ? event.target.closest(scheduleVisitTriggerSelector) : null;
                if (!(trigger instanceof HTMLElement)) return;
                event.preventDefault();
                event.stopPropagation();
                if (typeof event.stopImmediatePropagation === "function") {
                    event.stopImmediatePropagation();
                }
                ensureScheduleVisitScript()
                    .then(() => {
                        if (typeof window.g3OpenScheduleVisit === "function") {
                            window.g3OpenScheduleVisit(trigger);
                            return;
                        }
                        window.setTimeout(() => {
                            trigger.click();
                        }, 0);
                    })
                    .catch(() => {});
            }, true);
        }

        // Opening a form on arrival: the /schedule-visit/ page (data-auto-open) or ?open=schedule-visit from an email
        // (post-requirement is handled by home.js, which owns that form).
        const autoOpen = document.body?.dataset?.autoOpen || new URLSearchParams(window.location.search).get("open");
        if (autoOpen === "schedule-visit") {
            window.setTimeout(() => {
                // The page's own button first: it carries the project note (the navbar button does not).
                const trigger = document.querySelector(`main ${scheduleVisitTriggerSelector}`)
                    || document.querySelector(scheduleVisitTriggerSelector);
                if (trigger instanceof HTMLElement) trigger.click();
            }, 600);
        }

        const hasLeftRailStack = hasAny("[data-left-rail-stack]");
        if (hasLeftRailStack) {
            load("frontend/site/common/js/filters.js").catch(() => {});
        } else if (hasAny(".filter-form, .filter-panel, .range-track, #apply-price-btn")) {
            loadDeferred("frontend/site/common/js/filters.js", 4500);
        }
        document.querySelectorAll("[data-filter-more]").forEach((filterMore) => {
            if (!(filterMore instanceof HTMLElement) || filterMore.dataset.filterMoreReady === "1") return;
            const toggle = filterMore.querySelector("[data-filter-more-toggle]");
            if (!(toggle instanceof HTMLElement)) return;
            filterMore.dataset.filterMoreReady = "1";
            const close = () => {
                filterMore.classList.remove("is-open");
                toggle.setAttribute("aria-expanded", "false");
            };
            toggle.addEventListener("click", () => {
                const isOpen = filterMore.classList.toggle("is-open");
                toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
            });
            document.addEventListener("click", (event) => {
                if (!filterMore.classList.contains("is-open")) return;
                if (event.target instanceof Node && filterMore.contains(event.target)) return;
                close();
            });
            document.addEventListener("keydown", (event) => {
                if (event.key === "Escape") close();
            });
        });

        const hasLeftRailPromoCarousel = hasAny("[data-left-rail-promo-carousel]");
        if (hasLeftRailPromoCarousel) {
            load("frontend/site/common/js/ui-widgets.js").catch(() => {});
        } else if (hasAny(".locality-card, [data-scroll-target], [data-clean-hash], .subcat-panel, [data-sale-rent], [data-scroll-top], .testimonial-card[data-testimonial-id]")) {
            loadDeferred("frontend/site/common/js/ui-widgets.js", 6500);
        }

        const path = (window.location.pathname || "").toLowerCase();
        const isLowIntentPath = (
            path === "/blog/"
            || path.startsWith("/blog/")
            || path === "/blogs/"
            || path.startsWith("/blogs/")
        );
        const leadFlowEligible = (
            !document.body?.classList.contains("testimonial-page")
            && document.body?.dataset?.disableLeadFlow !== "true"
            && !isLowIntentPath
        );
        const inquiryTriggerSelector = "[data-inquiry-trigger='true'], #inquiry-modal";
        const inlineInquirySelector = "form[action*='/leads/submit'], form.listing-inquiry-form, form.nri-form, form.application-form, form.loan-form, #lead-form, #lead-form-modal";
        const hasInquiryTrigger = hasAny(inquiryTriggerSelector);
        const hasInlineInquiryForm = hasAny(inlineInquirySelector);
        const needsInquiry = leadFlowEligible || hasInquiryTrigger || hasInlineInquiryForm;
        let inquiryLoadPromise = null;
        const ensureInquiryScript = () => {
            if (window.__g3InquiryScriptReady === true) {
                return Promise.resolve();
            }
            if (!inquiryLoadPromise) {
                inquiryLoadPromise = load("frontend/site/common/js/inquiry.js")
                    .catch((error) => {
                        inquiryLoadPromise = null;
                        throw error;
                    });
            }
            return inquiryLoadPromise;
        };

        if (hasInlineInquiryForm) {
            ensureInquiryScript().catch(() => {});
        } else if (needsInquiry) {
            loadAfterDelayOrInput(() => {
                ensureInquiryScript().catch(() => {});
            }, 6500);
        }

        if (hasInquiryTrigger) {
            document.addEventListener("click", (event) => {
                if (window.__g3InquiryScriptReady === true) return;
                const trigger = event.target instanceof Element
                    ? event.target.closest('[data-inquiry-trigger="true"]')
                    : null;
                if (!(trigger instanceof HTMLElement)) return;
                event.preventDefault();
                event.stopPropagation();
                if (typeof event.stopImmediatePropagation === "function") {
                    event.stopImmediatePropagation();
                }
                ensureInquiryScript()
                    .then(() => {
                        window.setTimeout(() => {
                            trigger.click();
                        }, 0);
                    })
                    .catch(() => {});
            }, true);
        }

        if (leadFlowEligible) {
            window.addEventListener("load", () => {
                window.setTimeout(() => {
                    scheduleIdle(() => {
                        load("frontend/site/common/js/lead-flow.js").catch(() => {});
                    }, 900);
                }, 500);
            }, { once: true });
        }

        loadAfterDelayOrInput(() => {
            if (window.__g3AnalyticsTrackerRequested) {
                return;
            }
            window.__g3AnalyticsTrackerRequested = true;
            load("frontend/analytics/js/tracker.js").catch(() => {
                window.__g3AnalyticsTrackerRequested = false;
            });
        }, 9000);

        if (hasAny("[data-reveal], [data-parallax], img[data-img-fade], .motion-hero-accent")) {
            loadOnWindowIdle(() => {
                if (window.__g3MotionRequested) {
                    return;
                }
                window.__g3MotionRequested = true;
                load("frontend/site/common/js/motion.js").catch(() => {
                    window.__g3MotionRequested = false;
                });
            }, 9000);
        }

        const homeScriptSrc = String(document.body?.dataset?.homeScriptSrc || "").trim();
        if (homeScriptSrc) {
            const loadHomeScript = () => {
                if (window.__g3HomeScriptRequested) {
                    return;
                }
                window.__g3HomeScriptRequested = true;
                load(homeScriptSrc).catch(() => {
                    window.__g3HomeScriptRequested = false;
                });
            };
            const wantsRequirementForm = (document.body?.dataset?.autoOpen
                || new URLSearchParams(window.location.search).get("open")) === "post-requirement";
            if (wantsRequirementForm || hasAny("[data-home-inline-promo-carousel], [data-operations-promo-carousel]")) {
                loadHomeScript();
            } else {
                loadAfterDelayOrInput(loadHomeScript, 6500);
            }
            // "Post Your Requirement" clicked before home.js arrived: keep the click, load it, then open the form.
            document.addEventListener("click", (event) => {
                if (window.g3OpenOwnerListing) return;
                const trigger = event.target instanceof Element ? event.target.closest("[data-owner-listing-open]") : null;
                if (!trigger) return;
                event.preventDefault();
                loadHomeScript();
                const started = Date.now();
                const openWhenReady = () => {
                    if (typeof window.g3OpenOwnerListing === "function") {
                        window.g3OpenOwnerListing();
                    } else if (Date.now() - started < 8000) {
                        window.setTimeout(openWhenReady, 100);
                    }
                };
                openWhenReady();
            }, true);
            // A search tab tapped before home.js arrives (it loads on the first tap or after 6.5 s) used to be lost:
            // home.js then started in Buy, and a "Projects" search went to homes for sale (2026-10-18). The tab
            // switches here at once; home.js keeps it. The form already posts to /search/ without any script.
            document.addEventListener("click", (event) => {
                if (window.__g3HomeFilterReady) return;
                const tab = event.target instanceof Element ? event.target.closest("[data-home-filter] .filter-tab") : null;
                if (!tab) return;
                const root = tab.closest("[data-home-filter]");
                root.dataset.mode = tab.dataset.mode || "sell";
                root.querySelectorAll(".filter-tab").forEach((item) => {
                    const active = item === tab;
                    item.classList.toggle("is-active", active);
                    item.setAttribute("aria-selected", active ? "true" : "false");
                });
                const input = root.querySelector('[data-filter="search"]');
                if (input && tab.dataset.placeholder) input.placeholder = tab.dataset.placeholder;
                const modeInput = root.querySelector("[data-mode-input]");
                if (modeInput) modeInput.value = root.dataset.mode;
            }, true);
        }

        const projectDetailScriptSrc = String(document.body?.dataset?.projectDetailScriptSrc || "").trim();
        const projectPublicScriptSrc = String(document.body?.dataset?.projectPublicScriptSrc || "").trim();
        if (projectDetailScriptSrc || projectPublicScriptSrc) {
            if (projectDetailScriptSrc) {
                load(projectDetailScriptSrc).catch(() => {});
            }
            if (projectPublicScriptSrc) {
                load(projectPublicScriptSrc).catch(() => {});
            }
        }

        loadPageModule("projectBoardScriptSrc", 1200);
        loadPageModule("listingBoardScriptSrc", 0, "immediate");
        loadPageModule("listingDetailScriptSrc", 0, "immediate");
        loadPageModule("blogDetailScriptSrc", 5000);
        loadPageModule("homeLoanScriptSrc", 900, "immediate");
        loadPageModule("nriServicesScriptSrc", 1200, "immediate");
        loadPageModule("testimonialsScriptSrc", 1200, "immediate");
        loadPageModule("testimonialSubmitScriptSrc", 900, "immediate");

    };

    const initCookieBanner = () => {
        try {
            const dismissedKey = "g3CookieBannerDismissed";
            // consent_gate.js already hid it (html.g3-cookie-ok) for returning visitors.
            if (localStorage.getItem(dismissedKey) === "1") return;
            const banner = document.querySelector("[data-cookie-banner]");
            if (!banner) return;
            const acceptButton = banner.querySelector("[data-cookie-banner-accept]");
            acceptButton?.addEventListener("click", () => {
                banner.hidden = true;
                document.documentElement.classList.add("g3-cookie-ok");
                try {
                    localStorage.setItem(dismissedKey, "1");
                } catch (error) {
                    // Storage unavailable -- banner just won't stay dismissed across visits.
                }
            });
        } catch (error) {
            // Storage unavailable (private window, blocked) -- leave the banner hidden.
        }
    };

    const bootAll = () => {
        boot();
        initCookieBanner();
    };

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", bootAll, { once: true });
    } else {
        bootAll();
    }
})();


/* ==== shell-nav.js ==== */
(() => {
    const onReady = (fn) => {
        if (document.readyState === "loading") {
            document.addEventListener("DOMContentLoaded", fn, { once: true });
        } else {
            fn();
        }
    };

    onReady(() => {
        const isBuilderDirectoryPath = (pathname) => /^\/builders\/?$/.test(pathname) || /^\/builders-in-[^/]+\/?$/.test(pathname);
        const builderDirectoryPathForCity = (citySlug) => {
            const normalizedSlug = String(citySlug || "").trim().toLowerCase();
            return normalizedSlug ? `/builders-in-${normalizedSlug}/` : "/builders/";
        };
        const switchCityPathForCurrentPage = (citySlug) => {
            const normalizedSlug = String(citySlug || "").trim().toLowerCase();
            if (!normalizedSlug) return "";
            const url = new URL(window.location.href);
            url.searchParams.delete("city");
            const nextPath = `${url.pathname}${url.search}${url.hash}`;
            return `/select-city/${encodeURIComponent(normalizedSlug)}/?next=${encodeURIComponent(nextPath)}`;
        };

        document.querySelectorAll(".navbar").forEach((nav, index) => {
            const navContent = nav.querySelector(".nav-content");
            if (!navContent) return;

            let toggle = navContent.querySelector(".nav-toggle");
            if (!toggle) {
                toggle = document.createElement("button");
                toggle.type = "button";
                toggle.className = "nav-toggle";
                toggle.setAttribute("aria-expanded", "false");
                toggle.setAttribute("aria-label", "Toggle navigation");
                toggle.innerHTML = '<span class="nav-toggle-bar"></span><span class="nav-toggle-bar"></span><span class="nav-toggle-bar"></span>';
                navContent.appendChild(toggle);
            }

            let overlay = document.querySelector(`.nav-overlay[data-nav-id="${index}"]`);
            if (!overlay) {
                overlay = document.createElement("div");
                overlay.className = "nav-overlay";
                overlay.dataset.navId = String(index);
                document.body.appendChild(overlay);
            }

            let panel = document.querySelector(`.nav-panel[data-nav-id="${index}"]`);
            let main = null;
            let sub = null;
            if (!panel) {
                panel = document.createElement("div");
                panel.className = "nav-panel";
                panel.dataset.navId = String(index);
                panel.setAttribute("aria-hidden", "true");
                const track = document.createElement("div");
                track.className = "nav-panel-track";
                main = document.createElement("div");
                main.className = "nav-panel-main";
                sub = document.createElement("div");
                sub.className = "nav-panel-sub";
                track.append(main, sub);
                panel.appendChild(track);
                document.body.appendChild(panel);
            } else {
                panel.dataset.navId = String(index);
                panel.setAttribute("aria-hidden", panel.getAttribute("aria-hidden") || "true");
                main = panel.querySelector(".nav-panel-main");
                sub = panel.querySelector(".nav-panel-sub");
            }

            if (!panel.id) {
                panel.id = `nav-panel-${index}`;
            }
            toggle.setAttribute("aria-controls", panel.id);

            const syncNavHeight = () => {
                const height = nav.offsetHeight || 68;
                document.documentElement.style.setProperty("--nav-height", `${height}px`);
            };
            syncNavHeight();

            const desktopNavFitMq = window.matchMedia("(min-width: 1101px)");
            let navFitFrame = 0;
            const syncDesktopNavFit = () => {
                navFitFrame = 0;
                navContent.classList.remove("nav-fit-compact", "nav-fit-tight");
                if (!desktopNavFitMq.matches) {
                    return;
                }

                const fits = () => Math.ceil(navContent.scrollWidth) <= Math.ceil(navContent.clientWidth) + 2;
                if (fits()) {
                    return;
                }

                navContent.classList.add("nav-fit-compact");
                if (fits()) {
                    return;
                }

                navContent.classList.add("nav-fit-tight");
            };

            const requestDesktopNavFit = () => {
                if (navFitFrame) return;
                navFitFrame = window.requestAnimationFrame(syncDesktopNavFit);
            };

            requestDesktopNavFit();
            window.addEventListener("resize", requestDesktopNavFit);
            if (typeof desktopNavFitMq.addEventListener === "function") {
                desktopNavFitMq.addEventListener("change", requestDesktopNavFit);
            } else if (typeof desktopNavFitMq.addListener === "function") {
                desktopNavFitMq.addListener(requestDesktopNavFit);
            }
            if (document.fonts?.ready instanceof Promise) {
                document.fonts.ready.then(requestDesktopNavFit).catch(() => {});
            }
            if ("ResizeObserver" in window) {
                const navFitObserver = new ResizeObserver(requestDesktopNavFit);
                navFitObserver.observe(navContent);
            }

            const menu = navContent.querySelector(".menu");
            if (menu && main && !main.querySelector(".menu")) {
                const menuClone = menu.cloneNode(true);
                main.appendChild(menuClone);
                const dropdown = menuClone.querySelector(".dropdown");
                if (dropdown) {
                    const dropBtn = dropdown.querySelector(".drop-btn");
                    const dropdownMenu = dropdown.querySelector(".dropdown-menu");
                    if (dropBtn && dropdownMenu) {
                        const label = dropBtn.textContent.replace("▾", "").trim();
                        dropBtn.textContent = label;
                        dropBtn.classList.add("nav-submenu-trigger");
                        dropdownMenu.classList.add("nav-submenu");
                        dropdownMenu.removeAttribute("id");
                        dropBtn.removeAttribute("aria-controls");
                        const header = document.createElement("div");
                        header.className = "nav-submenu-header";
                        header.innerHTML = `<button class="nav-submenu-back" type="button" aria-label="Back to menu">&larr; Back</button><span class="nav-submenu-title">${label}</span>`;
                        dropdownMenu.prepend(header);
                        dropdownMenu.remove();
                        sub.appendChild(dropdownMenu);
                        dropdownMenu.dataset.navSubmenuReady = "1";
                    }
                }
            }

            const actions = navContent.querySelector(".actions");
            if (actions && main && !main.querySelector(".actions")) {
                main.appendChild(actions.cloneNode(true));
            }

            const closeNav = () => {
                document.body.classList.remove("nav-open");
                panel.classList.remove("nav-submenu-open");
                panel.setAttribute("aria-hidden", "true");
                toggle.setAttribute("aria-expanded", "false");
            };

            const openNav = () => {
                document.body.classList.add("nav-open");
                panel.setAttribute("aria-hidden", "false");
                toggle.setAttribute("aria-expanded", "true");
            };

            const onResize = () => {
                syncNavHeight();
                if (window.innerWidth > 900 && document.body.classList.contains("nav-open")) {
                    closeNav();
                }
            };
            window.addEventListener("resize", onResize);

            if (document.body.classList.contains("home-page")) {
                const heroBanner = document.querySelector(".home-hero-banner");
                let scrollTicking = false;

                const syncHomeNavState = () => {
                    scrollTicking = false;
                    if (window.innerWidth <= 900 || !heroBanner) {
                        document.body.classList.remove("home-nav-solid");
                        return;
                    }
                    const navHeight = nav.offsetHeight || 68;
                    const heroBottom = heroBanner.getBoundingClientRect().bottom;
                    document.body.classList.toggle("home-nav-solid", heroBottom <= navHeight + 8);
                };

                const queueHomeNavState = () => {
                    if (scrollTicking) return;
                    scrollTicking = true;
                    window.requestAnimationFrame(syncHomeNavState);
                };

                syncHomeNavState();
                window.addEventListener("scroll", queueHomeNavState, { passive: true });
                window.addEventListener("resize", queueHomeNavState);
                heroBanner?.querySelectorAll("img").forEach((image) => {
                    if (image.complete) return;
                    image.addEventListener("load", queueHomeNavState, { once: true });
                });
            }

            toggle.addEventListener("click", () => {
                if (document.body.classList.contains("nav-open")) {
                    closeNav();
                } else {
                    openNav();
                }
            });
            overlay.addEventListener("click", closeNav);
            document.addEventListener("keydown", (event) => {
                if (event.key === "Escape") {
                    closeNav();
                }
            });

            const trigger = panel.querySelector(".nav-submenu-trigger");
            const back = panel.querySelector(".nav-submenu-back");
            if (trigger) {
                trigger.addEventListener("click", (event) => {
                    event.preventDefault();
                    if (panel.querySelector(".dropdown-menu")) {
                        panel.classList.add("nav-submenu-open");
                    }
                });
            }
            if (back) {
                back.addEventListener("click", (event) => {
                    event.preventDefault();
                    panel.classList.remove("nav-submenu-open");
                });
            }

            panel.querySelectorAll("a[href]").forEach((link) => {
                link.addEventListener("click", closeNav);
            });
        });

        const navigateToCity = (select) => {
            const selectedOption = select.selectedOptions[0];
            const citySlug = selectedOption?.dataset?.citySlug || "";
            const url = new URL(window.location.href);
            if (isBuilderDirectoryPath(url.pathname)) {
                url.pathname = builderDirectoryPathForCity(citySlug);
                url.searchParams.delete("city");
                window.location.href = `${url.pathname}${url.search}${url.hash}`;
                return;
            }
            const switchPath = switchCityPathForCurrentPage(citySlug);
            if (switchPath) {
                window.location.href = switchPath;
                return;
            }
            url.searchParams.delete("city");
            window.location.href = `${url.pathname}${url.search}${url.hash}`;
        };

        const closeCityMenus = (except = null) => {
            document.querySelectorAll(".city-select.is-open").forEach((container) => {
                if (except && container === except) return;
                container.classList.remove("is-open");
                const trigger = container.querySelector(".city-select-trigger");
                if (trigger) {
                    trigger.setAttribute("aria-expanded", "false");
                }
            });
        };

        const setupCityDropdown = (select, index) => {
            const container = select.closest(".city-select");
            if (!container || container.dataset.cityDropdownReady === "1") {
                return;
            }
            container.dataset.cityDropdownReady = "1";
            container.classList.add("city-select--smart-ready");

            const trigger = document.createElement("button");
            trigger.type = "button";
            trigger.className = "city-select-trigger";
            trigger.setAttribute("aria-haspopup", "listbox");
            trigger.setAttribute("aria-expanded", "false");
            trigger.disabled = select.disabled;

            const menu = document.createElement("div");
            menu.className = "city-select-menu";
            menu.setAttribute("role", "listbox");
            menu.id = select.id ? `${select.id}-smart-menu` : `city-smart-menu-${index}`;
            trigger.setAttribute("aria-controls", menu.id);

            const syncMenu = () => {
                const options = Array.from(select.options);
                const selectedOption = select.selectedOptions[0] || options[0] || null;
                const selectedLabel = selectedOption ? selectedOption.textContent.trim() : "Select city";
                trigger.innerHTML = `<span class="city-select-trigger__label">${selectedLabel}</span><span class="city-select-trigger__chevron" aria-hidden="true">▾</span>`;
                menu.innerHTML = "";
                options.forEach((option) => {
                    const item = document.createElement("button");
                    item.type = "button";
                    item.className = "city-select-option";
                    item.setAttribute("role", "option");
                    item.dataset.value = option.value;
                    item.innerHTML = `<span class="city-select-option-label">${option.textContent.trim()}</span><span class="city-select-option-check" aria-hidden="true">✓</span>`;
                    if (option.selected) {
                        item.classList.add("is-selected");
                        item.setAttribute("aria-selected", "true");
                    } else {
                        item.setAttribute("aria-selected", "false");
                    }
                    item.addEventListener("click", () => {
                        if (option.disabled) return;
                        if (select.value !== option.value) {
                            select.value = option.value;
                        }
                        syncMenu();
                        closeCityMenus();
                        select.dispatchEvent(new Event("change", { bubbles: true }));
                    });
                    menu.appendChild(item);
                });
            };

            const syncVisibility = () => {
                select.hidden = true;
                select.tabIndex = -1;
                trigger.hidden = false;
                menu.hidden = false;
            };

            trigger.addEventListener("click", () => {
                if (trigger.disabled) {
                    return;
                }
                const willOpen = !container.classList.contains("is-open");
                closeCityMenus(container);
                container.classList.toggle("is-open", willOpen);
                trigger.setAttribute("aria-expanded", willOpen ? "true" : "false");
            });

            container.append(trigger, menu);
            select.addEventListener("change", syncMenu);
            syncMenu();
            syncVisibility();
        };

        document.querySelectorAll(".nav-city-select").forEach((select, index) => {
            setupCityDropdown(select, index);
            select.addEventListener("change", () => {
                closeCityMenus();
                navigateToCity(select);
            });
        });

        document.addEventListener("click", (event) => {
            if (!(event.target instanceof Element) || event.target.closest(".city-select")) {
                return;
            }
            closeCityMenus();
        });

        document.addEventListener("keydown", (event) => {
            if (event.key === "Escape") {
                closeCityMenus();
            }
        });

        const normalizePath = (path) => {
            if (!path) return "/";
            if (!path.startsWith("/")) return path;
            return path.endsWith("/") ? path : `${path}/`;
        };
        const currentPath = normalizePath(window.location.pathname);

        document.querySelectorAll(".menu a[href]").forEach((link) => {
            const href = link.getAttribute("href") || "";
            if (!href || href.startsWith("#") || href.startsWith("mailto:") || href.startsWith("tel:")) {
                return;
            }
            let linkPath = "";
            try {
                linkPath = new URL(href, window.location.origin).pathname;
            } catch (_) {
                return;
            }
            if (!linkPath.startsWith("/")) return;
            const normalizedLink = normalizePath(linkPath);
            const isActive = normalizedLink === "/"
                ? currentPath === "/"
                : currentPath.startsWith(normalizedLink);
            link.classList.toggle("is-active", isActive);
        });

        document.querySelectorAll(".dropdown").forEach((dropdown) => {
            if (dropdown.closest(".nav-panel")) return;
            const hasActive = Boolean(dropdown.querySelector(".drop-link.is-active"));
            dropdown.classList.toggle("is-active", hasActive);
        });

        const dropdowns = document.querySelectorAll(".dropdown");
        const isFineHover = () => window.matchMedia("(hover: hover) and (pointer: fine)").matches;
        const setExpanded = (drop, open) => {
            const btn = drop.querySelector(".drop-btn");
            if (btn) {
                btn.setAttribute("aria-expanded", open ? "true" : "false");
            }
        };
        const closeAll = () => {
            document.querySelectorAll(".dropdown.open").forEach((drop) => {
                drop.classList.remove("open");
                setExpanded(drop, false);
            });
        };
        const toggle = (drop, openNext) => {
            const isOpen = drop.classList.contains("open");
            const next = typeof openNext === "boolean" ? openNext : !isOpen;
            closeAll();
            if (next) {
                drop.classList.add("open");
                setExpanded(drop, true);
            }
        };

        dropdowns.forEach((drop) => {
            if (drop.closest(".nav-panel")) return;
            const btn = drop.querySelector(".drop-btn");
            const menu = drop.querySelector(".dropdown-menu");
            if (!btn || !menu) return;

            drop.addEventListener("click", (event) => event.stopPropagation());
            btn.addEventListener("click", (event) => {
                event.stopPropagation();
                const isTouchLike = window.matchMedia("(hover: none), (pointer: coarse)").matches || !isFineHover();
                if (isTouchLike) {
                    toggle(drop);
                    return;
                }
                toggle(drop);
            });
            btn.addEventListener("keydown", (event) => {
                if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    toggle(drop);
                    return;
                }
                if (event.key === "Escape") {
                    event.preventDefault();
                    closeAll();
                    btn.focus();
                }
            });
            menu.querySelectorAll("a[href]").forEach((link) => {
                link.addEventListener("click", () => {
                    if (!isFineHover()) {
                        closeAll();
                    }
                });
            });
        });

        document.addEventListener("click", closeAll);
        document.addEventListener("keydown", (event) => {
            if (event.key === "Escape") {
                closeAll();
            }
        });
        document.addEventListener("focusin", (event) => {
            if (event.target instanceof Element && event.target.closest(".dropdown")) return;
            closeAll();
        });
    });
})();
